import { createFileRoute } from '@tanstack/react-router'
import ContractorsPage from '@/spa/pages/ContractorsPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/contractors')({
  component: ContractorsPage,
  errorComponent: routeErrorComponent,
})
